import React from "react";

import "./BB8Badge.scss";

const BB8Badge = ({
  title,
  color
}: {
  title: string;
  color: "bb8-green" | "bb8-blue" | "bb8-orange" | "bb8-pink";
}) => <div className={`bb8-badge ${color}`}>{title}</div>;

export default BB8Badge;
